export default "__VITE_ASSET__Cu2buylr__"